export enum NounsType {
  Singular = 0,
  Plural = 1,
}
